import React from 'react';
import '../App.css';

function Containertxt() {
  return (
    <div className="txtone line-1 anim-typewriter">

      <h1 className='one'>AMERICAN SAS</h1>
      <h1 className='two'> CALIDAD Y PROFESIONALISMO </h1>
    </div>
  );
}

export default Containertxt;
